import {HttpAxiosRequest} from "../../httpAxiosBase";
import {EntityWithIdAndDescription} from "../../../types/baseEntities";
import {
    AfipResponsabilityType,
    ClientRelationshipTypeClassification
} from "../../../types/client/clientData";

export const HttpCacheClient = {
    getEndpoint: (url: string): string => `cache/cliente${url}`,

    getPhoneTypes: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClient.getEndpoint(`/telefono-tipo`)
        );
    },
    
    getGeneros: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClient.getEndpoint(`/genero`)
        );
    },

    getEstadosCiviles: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClient.getEndpoint(`/estado-civil`)
        );
    },

    getResponsableTipo: (): Promise<AfipResponsabilityType[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClient.getEndpoint(`/afip/reponsable-tipo`)
        );
    },

    getClienteClasificaciones: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClient.getEndpoint(`/clasificacion`)
        );
    },

    getRelacionTipos: (tinCodRelacionClasificacion?: number, clienteClasificacion?: number | null): Promise<ClientRelationshipTypeClassification[]> => {
        return HttpAxiosRequest.getWithQueryParams(
            HttpCacheClient.getEndpoint(`/relacion-clasificacion/${tinCodRelacionClasificacion}/relacion-tipo`),
            {
                'codClienteClasificacion': clienteClasificacion ?? null
            }
        );
    },
}